module.exports = __webpack_public_path__ + "img/bg.86310957.jpg";